/**
 * その他指示
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

const allocation_driver_instruction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    new ({ commit }, { driver_id }) {
      const api_path = `${API_PATH}/${driver_id}/instructions/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { driver_id, id }) {
      const api_path = `${API_PATH}/${driver_id}/instructions/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { driver_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/instructions`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    update ({ commit },{ driver_id, id, params }) {
      const api_path = `${API_PATH}/${driver_id}/instructions/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { driver_id, id }) {
      const api_path = `${API_PATH}/${driver_id}/instructions/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default allocation_driver_instruction

